<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置页面底部，为公共组件
 -->
<template>
    <div class="comp-footer comp">
        <div class="container">
            <div class="links">
                <a v-for="(link,index) in links" :key="link.n" :href="link.u" :title="link.n" :class="{last:index===links.length-1}">{{ link.n }}</a>
            </div>
            <div class="text">
                <div>{{ copyright }}</div>
                <div><span v-if="address">{{ address }}&emsp;&emsp;</span><span v-if="$cache.getCompanyInfo().publishnumber.trim()"><span v-html="recordnum"></span></span></div>
                <div><span>{{ servicephone }}</span>&emsp;&emsp;<span>{{ companyphone }}</span>&emsp;&emsp;<span> {{ fax }} </span>&emsp;&emsp;<span> {{ postcode }} </span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterCon",
    data () {
        return {
            links: [],
            copyright: "",
            recordnum: "",
            companyphone: "",
            servicephone: "",
            address: "",
            postcode: "",
            fax: ""
        };
    },
    mounted () {
        const companyInfo = this.$cache.getCompanyInfo();
        if (companyInfo) {
            this.links = JSON.parse(companyInfo.companyfootlink || "[]");
            if( companyInfo.copyrightinfo != ""){
                this.copyright = companyInfo.copyrightinfo;
            }
            if( companyInfo.publishnumber != ""){
                this.recordnum = companyInfo.publishnumber;
            }
            if( companyInfo.servicephone != ""){
                this.servicephone = "客户服务电话: " + companyInfo.servicephone;
            }
            if( companyInfo.companyphone != ""){
                this.companyphone = "公司办公电话: " + companyInfo.companyphone;
            }
            if( companyInfo.companyaddress != ""){
                this.address = companyInfo.companyaddress;
            }
            if( companyInfo.faxnumber != ""){
                this.fax = "传真: " + companyInfo.faxnumber;
            }
            if( companyInfo.companypostcode != ""){
                this.postcode = "邮编: " + companyInfo.companypostcode;
            }
        }
    }
};
</script>
<style lang="scss">
    .comp-footer {
        min-width: 1200px;
        height: 137px;
        text-align: center;
        padding: 30px 0 0 0;
        .links {
            line-height: 30px;
            a:after {
                content: '|';
                padding: 0 10px;
            }
            a.last:after {
                content: '';
                padding: 0;
            }
        }
        .text {
            text-align: left;
            position: relative;
            display: inline-block;
            div {
                line-height: 30px;
            }
            a {
                color: #666;
                &:hover {
                    color: #1479d7;
                }
            }
        }
    }
</style>
